import { useState } from 'react';
import { goQuery, filterInvalid } from '@bluevision/tools';

export default function useFilterModel() {
  // handle history code
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [filters, setFilters] = useState<any>(null);

  // handle history code
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const saveParams = (params: any) => {
    setFilters(params);
    goQuery(params);
  };

  // handle history code
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setParams = (params: any) => {
    const current = filterInvalid(params);
    if (current?.currentPage && current?.pageSize !== filters?.pageSize) {
      // 有参数变化时， 页码回到默认
      delete current.currentPage;
    }
    saveParams(current);
  };

  // handle history code
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const clearParams = (params?: any) => {
    saveParams(filterInvalid(params));
  };

  return {
    filters,
    setFilter: setParams,
    clearFilter: clearParams,
  };
}
